<div class="connexion">
    <div>
        <div>
            <img src="assets/img/logo.png" alt="SynthIA Logo" class="logo" />
          </div>
          <div>
            <img src="assets/img/logo_police_bleue.png" alt="SynthIA name" class="logot" />
          </div>
          <div>
              <div class="title">Connexion via un annuaire externe en cours</div>
          </div>
    </div>

</div>

